import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import { Typography } from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { useNavigate } from "react-router-dom";

interface IProps {
  title?: string;
  time?: string;
}

const ChatIssuesTableMainHeader = ({ title, time }: IProps) => {
  const navigate = useNavigate();

  const handleRedirectArcticlsViewAll = () => {
    const stateObj = {
      tabType: "chatbotMetrics",
    };
    navigate(`/articles`, { state: stateObj });
  };
  return (
    <Grid
      container
      sx={{
        background: "#dbdce04d",
        borderRadius: "8px 8px 0 0",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "5px",
      }}
    >
      <Typography
        sx={{
          fontWeight: 700,
          fontSize: "0.8rem",
          textTransform: "uppercase",
          paddingLeft: "10px",
        }}
      >
        {title}
      </Typography>

      <Button
        variant="text"
        sx={{
          color: "#2858D3",
          fontWeight: 700,
        }}
        onClick={handleRedirectArcticlsViewAll}
      >
        VIEW ALL
      </Button>
    </Grid>
  );
};

export default ChatIssuesTableMainHeader;
